import React from 'react';
import { Link } from 'react-router-dom';
import { LegalTemplate } from 'templates';
import { LegalDocument } from 'molecules';
import { legalDocs, LegalDocKey } from 'data/legal';
import { ROUTES } from 'constants/routes';

type LegalPageProps = {
  doc: LegalDocKey;
};

const LegalPage: React.FC<LegalPageProps> = ({ doc }) => {
  return (
    <LegalTemplate>
      <div className="legal-page">
        <Link className="legal-back" to={ROUTES.home}>
          ← Back
        </Link>
        <LegalDocument doc={legalDocs[doc]} />
      </div>
    </LegalTemplate>
  );
};

export default LegalPage;
